export const initialState = {
  user: localStorage.user && JSON.parse(localStorage.user).user,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'USER_DATA':
      return {
        ...state,
        user: action.user,
      };
    default:
      return state;
  }
};

export default reducer;
